import {
  ChangePasswordForm,
  ForgotPasswordForm,
  LoginForm,
  RegisterForm,
  ResetPasswordForm,
  UserProfileForm,
} from "@components/Forms";
import {
  FormWrapperExtraProps,
  FormWrapperProps,
} from "@picovico/ui/modules/FormWrapper/FormWrapper";

import { BoxProps } from "@chakra-ui/react";
import { FormWrapper } from "@picovico/ui";
import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function WithFormWrapper<P extends object>(
  Component: React.ComponentType<any>,
  defaultFormTitle?: string,
) {
  return function formWrappedFunction({
    formTitle,
    image,
    formElementProps,
    extraFields,
    ...props
  }: {
    formElementProps?: P;
    extraFields?: unknown;
  } & Pick<FormWrapperProps, "withImage" | "image"> &
    FormWrapperExtraProps & {
      formTitle?: string;
    }) {
    return (
      <FormWrapper
        formHeaderProps={{
          mt: "1rem",
        }}
        formTitle={formTitle || defaultFormTitle || "FormTitle"}
        image={image}
        {...props}
        formElement={
          <Component extraFields={extraFields} {...formElementProps} />
        }
      />
    );
  };
}

export const LoginFormCard = WithFormWrapper<BoxProps>(LoginForm, "Login");
export const RegisterFormCard = WithFormWrapper<BoxProps>(
  RegisterForm,
  "Register",
);
export const ForgotPasswordFormCard =
  WithFormWrapper<BoxProps>(ForgotPasswordForm);
export const ResetPasswordFormCard = WithFormWrapper<BoxProps>(
  ResetPasswordForm,
  "Reset Password",
);
export const ChangePasswordFormCard = WithFormWrapper<BoxProps>(
  ChangePasswordForm,
  "Change Password",
);

export const UserProfileFormCard = WithFormWrapper<BoxProps>(
  UserProfileForm,
  "Profile",
);
